import { useParams } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import CTABanner from "../components/CTABanner";
import { Reveal } from "../components/motion";
import useMeta from "../lib/useMeta";
import { breadcrumb } from "../lib/seo";
import { POLICIES } from "../lib/policies";

export default function Policy({ slugOverride }) {
  const { slug: paramSlug } = useParams();
  const slug = slugOverride || paramSlug;
  const policy = POLICIES[slug] || POLICIES.privacy;
  useMeta({
    title: `${policy.title} | Saarthva`,
    description: policy.intro,
    path: `/${slug}`,
    schemas: [breadcrumb(policy.title, `/${slug}`)],
  });

  return (
    <div data-testid={`policy-page-${slugOverride || paramSlug}`}>
      <PageHeader eyebrow="LEGAL" title={policy.title} description={policy.intro} />
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <p className="text-xs text-slate-400 mb-10">Last updated: September 2026</p>
          <div className="space-y-10">
            {policy.sections.map((s, i) => (
              <Reveal key={i} delay={i * 0.04}>
                <div data-testid={`policy-section-${i}`}>
                  <h2 className="font-display text-xl font-bold text-navy mb-3">{s.heading}</h2>
                  <p className="text-slate-600 leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
